module.exports = __webpack_public_path__ + "static/media/opkomst-leeftijd-procent.13bfef57.svg";


//////////////////
// WEBPACK FOOTER
// ./src/scenes/Seats/assets/opkomst-leeftijd-procent.svg
// module id = 476
// module chunks = 0